import { LOGIN_FUNNEL_SUPPORT_VERSION } from '@/constant';
import { appVersion } from '@/shared/utils/bootstrap';
import { versionCompare } from '@/shared/utils/versionCompare';
import URLUtils from '@/shared/utils/URLUtils';
import { callLocalGetTokenAndKey } from '.';
import platform from '../../shared/utils/platform';
import { getAuthUserInfo } from './aliMP';

const HBridge = import('@hb/hbridge');

// 哈啰出行APP，支付宝小程序；支付宝小程序；
export const getTokenAndKey = async (
  needLogin = true,
  /** 登录额外参数，主要用于外投场景，登录漏斗 */
  extendValue?: Dictionary,
): Promise<NativeModel.OriginUserInfo> => {
  if (platform.isAlipayMini) {
    const res = await (await HBridge).Native.getTokenAndKey({
      needLogin: false,
    }).catch(() => ({}));

    if (needLogin && !Object.keys(res).length) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, no-return-await
      return (await getAuthUserInfo({}));
    }
    return res as NativeModel.OriginUserInfo;
  }

  // app中登录增加入参
  if (versionCompare(appVersion, LOGIN_FUNNEL_SUPPORT_VERSION) >= 0
    && platform.isEasyBike && extendValue) {
    return callLocalGetTokenAndKey(needLogin, extendValue);
  }
  const query = URLUtils.getQueryMap();
  /**
   * 微信小程序场景，若helloToken过期，不用登录的页面进来后，也使用h5Bridge缓存token，所以请求接口异常
   * 先临时处理：不用登录的页面的先清空token缓存
   * TODO: 后续优化
   * */
  if (platform.isWechatMini && query?.isNeedLogin === 'false') {
    (await HBridge).Native.logout();
  }

  return (await HBridge).Native.getTokenAndKey({ needLogin });
};
